module.exports = __webpack_public_path__ + "static/media/Concept_Buildings_02.576ba025.jpg";